import { render, staticRenderFns } from "./Securitycameras.vue?vue&type=template&id=56613b2e&scoped=true&"
import script from "./Securitycameras.vue?vue&type=script&lang=js&"
export * from "./Securitycameras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56613b2e",
  null
  
)

export default component.exports